<nb-layout windowMode>
  <nb-layout-column class="layout">
    <div class="login-container">
      <div class="login-main">
        <div class="logo-container">
          <img class="logo" src="assets/images/logo.png" alt="کافی‌نت ایران" />
          <span>کافی‌نت ایران</span>
        </div>

        <div class="login-form-container">
          <div class="login-form">
            <div>
              <h1 class="title">ورود به <span>کافی‌نت ایران</span></h1>
              <p class="description">
                روش ورود خود را انتخاب و اطلاعات را تکمیل نمایید.
              </p>
            </div>

            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="login-mode-switch">
                <button
                  nbButton
                  type="button"
                  size="small"
                  [status]="loginMode === 'password' ? 'primary' : 'basic'"
                  (click)="setLoginMode('password')"
                >
                  رمز عبور
                </button>

                <button
                  nbButton
                  type="button"
                  size="small"
                  [status]="loginMode === 'otp' ? 'primary' : 'basic'"
                  (click)="setLoginMode('otp')"
                >
                  کد تایید
                </button>
              </div>

              <ngx-input-field
                type="tel"
                label="شماره موبایل"
                [inputAttrs]="{ maxlength: 11 }"
                autocomplete="tel"
                placeholder="مثال: 09123456789"
                formControlName="phone"
                [control]="form.get('phone')"
                [disabled]="loginMode === 'otp' && otpStep === 'verify'"
              ></ngx-input-field>

              <ngx-input-field
                *ngIf="loginMode === 'password'"
                type="password"
                label="رمز عبور"
                autocomplete="current-password"
                placeholder="رمز عبور"
                formControlName="password"
                [control]="form.get('password')"
              ></ngx-input-field>

              <ngx-input-field
                *ngIf="loginMode === 'otp' && otpStep === 'verify'"
                type="tel"
                label="کد تایید"
                placeholder="کد ارسال شده"
                autocomplete="one-time-code"
                formControlName="code"
                [control]="form.get('code')"
              ></ngx-input-field>

              <div
                *ngIf="loginMode === 'otp' && otpStep === 'verify'"
                class="label"
                style="margin-top: 8px"
              >
                <span
                  class="change-phone-btn"
                  (click)="handleChangePhone()"
                  style="cursor: pointer; margin-left: 12px"
                >
                  تغییر شماره موبایل
                </span>

                <span
                  *ngIf="canResendCode"
                  class="change-phone-btn"
                  (click)="resendCode()"
                  style="cursor: pointer"
                >
                  درخواست مجدد کد تایید
                </span>

                <span *ngIf="!canResendCode && resendRemainingSeconds > 0">
                  ارسال مجدد کد تا {{ resendRemainingSeconds }} ثانیه دیگر
                </span>

                <span *ngIf="resendLoading"> در حال ارسال مجدد کد... </span>
              </div>

              <button
                nbButton
                type="submit"
                status="primary"
                [disabled]="loading || form.invalid"
              >
                {{ submitButtonLabel }}
              </button>
            </form>
          </div>
        </div>
      </div>

      <div class="login-image">
        <img
          class="logo-login"
          src="assets/images/logo.png"
          alt="کافی‌نت ایران"
        />
      </div>
    </div>
  </nb-layout-column>
</nb-layout>
